module.exports = __webpack_public_path__ + "static/media/AboutUsImg.6c3912ff.jpg";